import { Component, ViewEncapsulation, ViewContainerRef, ComponentRef, ChangeDetectorRef } from "@angular/core";
import { formatDate } from '@angular/common';
import { FormOptionComponent } from "./form/form.component";
import { IFormOptions } from "./form/form.interface";
import { DateFormatView, PASSWORD_PATTERN } from 'src/app/shared/shared.const';
import { SharedService } from "./shared.service";
import { ConfirmBoxEvokeService } from '@costlydeveloper/ngx-awesome-popup';
import { ToastrService } from 'ngx-toastr';
import { UserRolesEnum, IPopupFormConfig, IUserPopupFormConfig } from "./shared.interface";
import { BehaviorSubject } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

import { RevoGrid } from '@revolist/revogrid/dist/types/interfaces';

import * as moment from 'moment';
import { UserActivityPopupComponent } from "src/app/shared/user-activity-popup/user-activity-popup.component";
declare var jsPanel: any;


@Component({
    selector: 'app-shared-component',
    template: '',
    encapsulation: ViewEncapsulation.None
})
export class SharedComponent {
    jsPanelPopup: any;
    componentRef: ComponentRef<FormOptionComponent>;

    dataList: any[] = [];

    source: any[] = [];
    columns: RevoGrid.CellProps[] = [];

    studyNames: string[] = [];
    siteNames: string[] = [];

    selectedStudyNames: string[] = [];
    selectedSiteNames: string[] = [];

    dropdownSettings: IDropdownSettings = {
        singleSelection: false,
        itemsShowLimit: 2,
        allowSearchFilter: true,
        maxHeight: 150
    };

    studyList$: BehaviorSubject<any[]> = new BehaviorSubject([]);
    siteList$: BehaviorSubject<any[]> = new BehaviorSubject([]);
    siteStudyList$: BehaviorSubject<any[]> = new BehaviorSubject([]);

    get studyName() {
        if (this.sharedService.Role === UserRolesEnum.Administrator) {
            return null;
        }
        return this.studyNames.length === 1 ? this.studyNames[0] : null;
    }

    get revoGrid() {
        const grid: any = document.querySelector("revo-grid");
        return grid;
    }


    constructor(protected vcr: ViewContainerRef,
        protected sharedService: SharedService,
        protected toastrService: ToastrService,
        protected confirmBoxService: ConfirmBoxEvokeService,
        protected cdrf: ChangeDetectorRef) {
    }

    panelWidth(width = 460) {
        return Math.min(width, window.innerWidth * 0.9);
    }

    panelHeight(height = 500) {
        return Math.min(height, window.innerHeight * 0.9);
    }

    showFormPopup(config: IPopupFormConfig, callback) {

        var formOptions = config.formOptions || [];
        var formData = config.formData || {};
        var submitButton = config.submitButton || "Inviare";
        var cancelButton = config.cancelButton || "Cancellare";
        var footerButtons = config.footerButtons || [];

        if (config.panelVisible && this.componentRef != undefined) {
            this.componentRef.instance.updateOptions(formOptions, formData, submitButton, cancelButton, footerButtons);
        } else {
            let panels = jsPanel.getPanels();
            panels.forEach(panel => {
                panel.close();
            })

            this.componentRef = this.vcr.createComponent(FormOptionComponent);
            this.componentRef.instance.formOptions = formOptions;
            this.componentRef.instance.formData = formData;
            this.componentRef.instance.submitButton = submitButton;
            this.componentRef.instance.cancelButton = cancelButton;
            this.componentRef.instance.footerButtons = footerButtons;

            this.componentRef.instance.formEmitter.subscribe(res => {
                switch (res.type) {
                    case 'save':
                        callback({
                            value: res.value,
                            jsPanelPopup: this.jsPanelPopup
                        });
                        break;
                    default:
                        this.jsPanelPopup.close();
                        break;
                }
            })
        }

        const element = this.componentRef.location.nativeElement;
        this.cdrf.detectChanges();

        if (config.panelVisible != true || this.jsPanelPopup === undefined) {
            this.jsPanelPopup = jsPanel.create({
                id: "jsPanelFixed",
                theme: 'dark',
                headerTitle: config.title,
                headerControls: {
                    smallify: 'remove',
                    minimize: 'remove',
                    normalize: 'remove',
                    maximize: 'remove'
                },
                panelSize: {
                    width: () => { return this.panelWidth(config.panelSize?.width); },
                    height: () => { return this.panelHeight(config.panelSize?.height); }
                },
                animateIn: 'jsPanelFadeIn',
                onwindowresize: true,
                dragit: {
                    disable: !config.dragit
                },
                resizeit: {
                    disable: !config.resizeit
                },
                content: element
            });
        } else {
            this.jsPanelPopup.content = element;
        }
        this.cdrf.detectChanges();
    }

    createUser = (Role: UserRolesEnum, config: IUserPopupFormConfig, callback) => {
        config.formData = {
            Anonymized: this.sharedService.AnonymousStudy
        }
        config.formOptions = [
            ...config.preFormOptions ? config.preFormOptions : [],
            {
                type: 'input',
                controlName: 'FirstName',
                label: 'Nome di battesimo',
                dependentControl: true
            },
            {
                type: 'input',
                controlName: 'LastName',
                label: 'Cognome',
                dependentControl: true
            },
            {
                type: 'input',
                controlName: 'Email',
                label: 'Indirizzo e-mail',
                validators: {
                    email: true
                },
                dependentControl: true
            },
            {
                type: 'input',
                controlName: 'UserName',
                label: this.sharedService.getUserNameLabel(Role),
                validators: {
                    required: true
                }
            },
            {
                type: 'password',
                controlName: 'Password',
                label: 'password',
                validators: {
                    required: true,
                    pattern: PASSWORD_PATTERN
                }
            },
            {
                type: 'input',
                controlName: 'Role',
                label: 'ruolo',
                defaultValue: Role,
                readonly: true,
                hidden: true
            },
            ...config.postFormOptions ? config.postFormOptions : []
        ];
        this.showFormPopup(config, (resp) => {
            callback(resp);
        });
    }

    updateUser = (Id, config: IUserPopupFormConfig, callback) => {
        var userData = this.dataList.find(a => a.Id === Id);
        var formData = Object.assign({}, userData);
        config.formData = {
            ...formData,
            Anonymized: formData.Anonymized
        };
        config.formOptions = [
            {
                controlName: 'Id',
                type: 'input',
                hidden: true
            },
            ...config.preFormOptions ? config.preFormOptions : [],
            {
                type: 'input',
                controlName: 'FirstName',
                label: 'Nome di battesimo',
                dependentControl: true
            },
            {
                type: 'input',
                controlName: 'LastName',
                label: 'Cognome',
                dependentControl: true
            },
            {
                type: 'input',
                controlName: 'Email',
                label: 'Indirizzo e-mail',
                validators: {
                    email: true
                },
                dependentControl: true
            },
            {
                type: 'input',
                controlName: 'UserName',
                label: this.sharedService.getUserNameLabel(userData.Role),
                readonly: true
            },
            {
                type: 'input',
                controlName: 'Role',
                label: 'ruolo',
                readonly: true,
                hidden: true
            },
            ...config.postFormOptions ? config.postFormOptions : []
        ];
        this.showFormPopup(config, (resp) => {
            callback(resp);
        });
    }

    deleteUser = (Id: string, title: string, type: string, callback) => {
        var userData = this.dataList.find(a => a.Id === Id);
        var message = `Sei sicuro che l'utente <strong>${userData.UserName}</strong> debba essere eliminato?`;
        this.deletePopup(title, message, (resp) => {
            this.sharedService.deleteUser(Id).subscribe({
                next: (res) => {
                    this.toastrService.success(`L'utente <strong>${userData.UserName}</strong> è stato eliminato con successo`);
                    callback(true);
                },
                error: (err) => {
                    this.toastrService.error(err);
                }
            })
        })
    }

    resetPassword = (Id: string) => {
        var userData = this.dataList.find(a => a.Id === Id);

        let formOptions: IFormOptions[] = [
            {
                type: 'password',
                controlName: 'NewPassword',
                label: 'password',
                validators: {
                    required: true,
                    pattern: PASSWORD_PATTERN
                },
                passwordValidation: {
                    dependentBy: 'NewPassword',
                    dependentTo: 'ConfirmPassword'
                }
            },
            {
                type: 'password',
                controlName: 'ConfirmPassword',
                label: 'Conferma password',
                validators: {
                    required: true,
                    pattern: PASSWORD_PATTERN
                },
                passwordValidation: {
                    dependentBy: 'NewPassword',
                    dependentTo: 'ConfirmPassword'
                }
            }
        ];
        this.showFormPopup({
            title: `Aggiorna la password per <strong>${userData.UserName}<strong>`,
            formOptions,
            panelSize: { height: 320 }
        }, (resp) => {
            let payload = resp.value;

            if (payload) {
                this.sharedService.resetUserPassword(Id, payload).subscribe({
                    next: (res) => {
                        this.toastrService.success(`Password aggiornata con successo`);
                        if (resp.jsPanelPopup) {
                            resp.jsPanelPopup.close();
                        }
                    },
                    error: (err) => {
                        this.toastrService.error(err);
                    }
                })
            }
        });
    }

    deletePopup = (title: string, message: string, callback) => {
        this.confirmBoxService.danger(title, message, 'Confermare', 'Rifiutare').subscribe(resp => {
            if (resp.success) {
                callback(true)
            }
        })
    }

    viewLoginHistory = (userId) => {
        this.sharedService.getUserActivityList(userId).subscribe({
            next: (res: any) => {
                this.openUserActivityPopup(userId, res);
            },
            error: (err: any) => {
                this.toastrService.error(err);
            }
        })
    }

    openUserActivityPopup(userId: string, activityList: any[]) {
        var userData = this.dataList.find(a => a.Id === userId);

        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let componentRef = this.vcr.createComponent(UserActivityPopupComponent);
        componentRef.instance.activityList = [...activityList];

        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            id: "jsPanelFixed",
            theme: 'dark',
            headerTitle: `<div class="py-2">Elenco attività per l'utente <strong>${userData.UserName}</strong><div>`,
            headerControls: {
                // close: 'remove',
                smallify: 'remove',
                minimize: 'remove',
                normalize: 'remove',
                maximize: 'remove'
            },
            panelSize: {
                width: () => { return this.panelWidth(1200) },
                height: () => { return this.panelHeight(1600) }
            },
            animateIn: 'jsPanelFadeIn',
            onwindowresize: true,
            dragit: {
                disable: false
            },
            resizeit: {
                disable: false
            },
            content: element
        });
        this.jsPanelPopup.header.style.backgroundColor = '#004d81';
    }
}
